// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  SpanWithData,
  SvgIcon,
  WorkflowRunStep
} from '../'

export const WorkflowStepsTableDataRow = ({ workflowRunStep, expanded, noExpand, onClick }) => {
  let workflowRunStepId = workflowRunStep.id
  let assignedTo = workflowRunStep.assignedTo ? workflowRunStep.assignedTo.firstName : "none"
  let scheduledAt = moment(workflowRunStep.scheduledAt).format('DD MMM YYYY HH:mm')
  let updatedAt = moment(workflowRunStep.updatedAt).format('DD MMM YYYY HH:mm')

  return (
    <React.Fragment>
      <tr className={`slds-hint-parent ${noExpand ? '': 'clickable'}`} title={workflowRunStep.workflowstep.name} onClick={onClick}>
        <td role="gridcell" style={expanded ? { borderLeft: '2px solid darkgreen' } : null}>
          <div className="slds-truncate">
            {workflowRunStep.workflowstep.number+"."}
            &nbsp;
            <span style={{ color: 'green' }}>
              {workflowRunStep.workflowstep.name}
            </span>
          </div>
        </td>
        <td role="gridcell">
          <div className="slds-grid slds-truncate">
            <SvgIcon
              variant='utility'
              size='x-small'
              symbol={workflowRunStep.status === "PROCESSED"
                ? "success"
                : workflowRunStep.status === "FAILED"
                  ? "warning"
                  : workflowRunStep.status === "PROCESSING"
                    ? "threedots"
                    : workflowRunStep.status === "READY"
                      ? "power"
                      : workflowRunStep.status === "PENDING"
                        ? "clock"
                        : "question"  // unknown
              }
            />
            &nbsp;&nbsp;
            <SpanWithData
              forField="WorkflowRunStepStatus"
              searchKey={workflowRunStep.status}
            />
          </div>
        </td>
        {/*<td role="gridcell">
          <div className="slds-truncate" title={assignedTo}>
            {assignedTo}
          </div>
        </td>
        <td role="gridcell">
          <div className="slds-truncate" title={scheduledAt}>
            {scheduledAt}
          </div>
        </td>*/}
        <td role="gridcell">
          <div className="slds-truncate" title={updatedAt}>
            {updatedAt}
          </div>
        </td>
      </tr>
      {expanded &&
        <tr>
          <td colSpan={5} style={{ borderLeft: '3px solid darkgreen' }}>
            <WorkflowRunStep id={workflowRunStepId} />
          </td>
        </tr>
      }
    </React.Fragment>
  )
}

WorkflowStepsTableDataRow.propTypes = {
  workflowRunStep: PropTypes.object.isRequired,
  expanded: PropTypes.bool,
  noExpand: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/workflow-run-steps/WorkflowStepsTableDataRow.js